module.exports = __webpack_public_path__ + "img/55_2023_07_19.7b99d1f4.jpg";